import React from "react";

const CouponAmount = ({ specialDate, data }) => {
  return (
    <div className="col-md-5">
      <div className="roles-bg rounded-4 mt-0 pb-4">
        <h2 className=" f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
          Coupon & Wallet Amount
        </h2>
        {specialDate && (
          <div className="d-flex as-js mt-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
              {" "}
              Normal Price
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : 2500
            </p>
          </div>
        )}
        {specialDate && (
          <div className="d-flex as-js mt-3">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
              {" "}
              Special Date Price
            </p>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
              {" "}
              : 2500{" "}
            </p>
          </div>
        )}
        <div className="d-flex as-js mt-3">
          <p
            className={`f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6 ${
              specialDate && "primary"
            }`}
          >
            {" "}
            Total Price
          </p>
          <p
            className={`f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2 ${
              specialDate && "primary"
            }`}
          >
            {" "}
            : {data?.total_amount}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Coupon Amount
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.coupon_amount ?? "-"}{" "}
            {data?.coupon_code && (
              <span className="sec f2">({data?.coupon_code}) </span>
            )}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Wallet Amount
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.wallet_amount}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Tips Method
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.tips}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Total Payable
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.total_payable}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Amount Paid
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.paid_amount}{" "}
          </p>
        </div>
        <div className="d-flex as-js mt-3">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            {" "}
            Balance Amount
          </p>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  gray2">
            {" "}
            : {data?.balance_to_pay}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponAmount;
